import { isAxiosError } from 'axios';

function pickFirstMessage(value: unknown): string | null {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const message = pickFirstMessage(item);
      if (message) {
        return message;
      }
    }
  }

  if (value && typeof value === 'object') {
    for (const nestedValue of Object.values(value)) {
      const message = pickFirstMessage(nestedValue);
      if (message) {
        return message;
      }
    }
  }

  return null;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const responseMessage = pickFirstMessage(error.response?.data);
    if (responseMessage) {
      return responseMessage;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}